import {
  Lien,
  RecordedDocument,
  EnvironmentalControlBoardJudgment,
  ParkingViolationJudgment,
  TransitAdjudicationBureauJudgment,
} from 'pages/Search/models';

export interface SearchDetailsState {
  details:
    | null
    | Lien
    | RecordedDocument
    | EnvironmentalControlBoardJudgment
    | ParkingViolationJudgment
    | TransitAdjudicationBureauJudgment;
  loading: boolean;
}

export const SEARCH_DETAILS_ADD = 'SEARCH_DETAILS_ADD';
export const SEARCH_DETAILS_CLEAR = 'SEARCH_DETAILS_CLEAR';
export const SEARCH_DETAILS_LOADING = 'SEARCH_DETAILS_LOADING';

interface SearchDetailsAddAction {
  type: typeof SEARCH_DETAILS_ADD;
  payload:
    | Lien
    | RecordedDocument
    | EnvironmentalControlBoardJudgment
    | ParkingViolationJudgment
    | TransitAdjudicationBureauJudgment;
}

interface SearchDetailsClearAction {
  type: typeof SEARCH_DETAILS_CLEAR;
}

interface SearchDetailsLoadingAction {
  type: typeof SEARCH_DETAILS_LOADING;
  payload: boolean;
}

export type SearchDetailsActionTypes =
  | SearchDetailsAddAction
  | SearchDetailsClearAction
  | SearchDetailsLoadingAction;
